<router-outlet />
	@defer (on idle; hydrate on idle) {
		<now-playing-widget></now-playing-widget>
	} @placeholder { }
